<app-form-header class="backoffice-page-header"></app-form-header>
<div>
  <div class="page-content mat-elevation-z2">

    <mat-accordion>
      <mat-expansion-panel class="filter-style" [expanded]="panelOpenState" (opened)="panelOpenState = true"
                           (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <span>
              Cuadro de filtros
            </span>
          </mat-panel-title>
          <mat-panel-description *ngIf="!panelOpenState">
            Haga clic para desplegar y acceder a los filtros
          </mat-panel-description>
          <mat-panel-description *ngIf="panelOpenState">
            Haga clic para ocultar los filtros.
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="formFilter" fxLayout="row" fxLayoutAlign="space-around center">
          <mat-form-field appearance="outline">
            <mat-label>Fecha Compra</mat-label>
            <input matInput [matDatepicker]="pickerDesde" formControlName="fechaCompra">
            <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
            <mat-datepicker #pickerDesde></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput placeholder="Nombre" formControlName="nombre">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Apellido</mat-label>
            <input matInput placeholder="Apellido" formControlName="apellido">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Comercio</mat-label>
            <input matInput placeholder="Comercio" formControlName="comercio">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Estado Solicitud</mat-label>
            <mat-select formControlName="estadoSolicitudId">
              <mat-option *ngFor="let l of estadoList" [value]="l.id">
                {{l.nombre}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </form>

        <button mat-raised-button color="primary" (click)="exportar()">
          <mat-icon>receipt_long</mat-icon>
          Exportar Excel
        </button>

      </mat-expansion-panel>
    </mat-accordion>

    <div>
      <table mat-table [dataSource]="dataSource" matSort matSortActive="documento">

        <ng-container matColumnDef="fechaHora">
          <th mat-header-cell *matHeaderCellDef> Fecha </th>
          <td mat-cell *matCellDef="let e"> {{e.fechaHora | date: 'dd/MM/yyyy HH:mm'}} </td>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef> Nombre </th>
          <td mat-cell *matCellDef="let e"> {{e.nombre}} </td>
        </ng-container>

        <ng-container matColumnDef="apellido">
          <th mat-header-cell *matHeaderCellDef> Apellido </th>
          <td mat-cell *matCellDef="let e"> {{e.apellido}} </td>
        </ng-container>

        <ng-container matColumnDef="nroSolicitud">
          <th mat-header-cell *matHeaderCellDef> N° Solicitud </th>
          <td mat-cell *matCellDef="let e"> {{e.nroSolicitud}} </td>
        </ng-container>

        <ng-container matColumnDef="estadoSolicitud">
          <th mat-header-cell *matHeaderCellDef> Estado Solicitud </th>
          <td mat-cell *matCellDef="let e"> {{e.estadoSolicitud}} </td>
        </ng-container>

        <ng-container matColumnDef="importe">
          <th mat-header-cell *matHeaderCellDef> Importe</th>
          <td mat-cell *matCellDef="let e"> {{e.importe | number}} </td>
        </ng-container>

        <ng-container matColumnDef="comercio">
          <th mat-header-cell *matHeaderCellDef> Comercio</th>
          <td mat-cell *matCellDef="let e"> {{e.comercio}} </td>
        </ng-container>

       <!-- <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef> Acciones</th>
          <td mat-cell *matCellDef="let e">
            <button mat-menu-item (click)="mostrarDetalle(e)">
              <mat-icon>visibility
              </mat-icon>
            </button>
          </td>
        </ng-container>-->
        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef> Acciones</th>
          <td mat-cell *matCellDef="let e">
            <button mat-menu-item [matMenuTriggerFor]="menu">
              <mat-icon>more_horizontal</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog(e)">
                <mat-icon>remove_red_eye</mat-icon>
                Ver carrito
              </button>
              <button mat-menu-item (click)="openDialogDatos(e)">
                <mat-icon>edit</mat-icon>
                Datos de Compra
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [length]="paginacion?.cantidad" [pageSize]="paginacion?.por_pagina" (page)="obtenerDatos($event)">
    </mat-paginator>
  </div>
</div>
